/* ============================================
   LINEE — Page-specific JavaScript
   Prodotti carousel, LineaStory, Lines section
   ============================================
   Requires shared.js loaded first (preloader,
   Lenis, burger menu, cursor, nav scroll).
   Uses window.lenis for scroll control.
   ============================================ */


/* ---------- HERO LINEE — animazione post preloader ---------- */
(function () {
  var hero    = document.querySelector('.linee-hero');
  var card    = document.querySelector('.linee-hero__video-card');
  var name    = document.querySelector('.linee-hero__name');
  var tagline = document.querySelector('.linee-hero__tagline');
  var body    = document.querySelector('.linee-hero__body');
  var nav     = document.querySelector('.dett-nav');
  var bottom  = document.querySelector('.dett-hero__bottom');
  if (!hero) return;

  function runIntro() {
    var tl = gsap.timeline({ defaults: { ease: 'power3.out' } });

    if (nav)    tl.from(nav,    { yPercent: -100, opacity: 0, duration: 0.8 }, 0);
    if (bottom) tl.from(bottom, { yPercent: 100,  opacity: 0, duration: 0.8 }, 0);

    if (card) {
      gsap.set(card, { y: 24 });
      tl.to(card, { opacity: 1, y: 0, duration: 1 }, 0.15);
    }

    if (name) {
      gsap.set(name, { y: 30 });
      tl.to(name, { opacity: 1, y: 0, duration: 1.2 }, 0.25);
    }

    if (tagline) {
      gsap.set(tagline, { y: 20 });
      tl.to(tagline, { opacity: 1, y: 0, duration: 1 }, 0.5);
    }

    if (body) {
      gsap.set(body, { y: 16 });
      tl.to(body, { opacity: 1, y: 0, duration: 0.9 }, 0.65);
    }
  }

  window.addEventListener('preloader-done', runIntro, { once: true });
})();


/* ---------- HERO LINEE — scroll dissolve ---------- */
(function () {
  var hero  = document.querySelector('.linee-hero');
  var panel = document.querySelector('.linee-hero__panel');
  if (!hero) return;

  gsap.timeline({
    scrollTrigger: {
      trigger: hero,
      start: 'top top',
      end: 'bottom top',
      scrub: 1,
    },
  })
  .to(panel, { yPercent: -15, opacity: 0, ease: 'none' }, 0)
  .to('.linee-hero__bg', { scale: 1.06, ease: 'none' }, 0);
})();


/* ---------- PROMESSA DI DAFNE — image reveal + text ---------- */
(function () {
  var section = document.querySelector('.linee-promessa');
  if (!section) return;

  /* Barretta verticale — cresce come brand-filosofia */
  var content = section.querySelector('.linee-promessa__content');
  if (content) {
    gsap.to(content, {
      '--line-h': '100%',
      duration: 1.2,
      ease: 'power2.out',
      scrollTrigger: { trigger: content, start: 'top 80%' },
    });
  }

  /* Parallax bg */
  var bg = section.querySelector('.linee-promessa__bg');
  if (bg) {
    gsap.fromTo(bg, { yPercent: -8 }, {
      yPercent: 8,
      ease: 'none',
      scrollTrigger: {
        trigger: section,
        start: 'top bottom',
        end: 'bottom top',
        scrub: 1,
      },
    });
  }

  /* SVG circle mask reveal con displacement */
  var maskCircle = section.querySelector('#circleMask-promessa circle');
  var svgImage   = maskCircle ? section.querySelector('.linee-promessa__image image') : null;
  if (maskCircle && svgImage) {
    var finalR = parseFloat(maskCircle.getAttribute('data-value-final'));
    if (window.innerWidth <= 1024) {
      maskCircle.setAttribute('r', finalR);
    } else {
      gsap.timeline({
        scrollTrigger: {
          trigger: '.linee-promessa__image',
          start: 'top 85%',
          end: '+=40%',
          scrub: true,
        },
      })
      .fromTo(maskCircle, { attr: { r: 0 } }, { attr: { r: finalR }, ease: 'none' }, 0)
      .fromTo(svgImage, { scale: 1.08, transformOrigin: '50% 50%' }, { scale: 1, ease: 'none' }, 0);
    }
  }

  /* Parallax image — scorre verso l'alto mentre si scrolla */
  var promImage = section.querySelector('.linee-promessa__image');
  if (promImage) {
    gsap.fromTo(promImage, { yPercent: -12 }, {
      yPercent: 12,
      ease: 'none',
      scrollTrigger: {
        trigger: section,
        start: 'top bottom',
        end: 'bottom top',
        scrub: 1.5,
      },
    });
  }

  /* Titolo — SplitType line reveal (ogni riga sale da overflow hidden) */
  var title = section.querySelector('.linee-promessa__title');
  if (title && typeof SplitType !== 'undefined') {
    var titleSplit = new SplitType(title, { types: 'lines' });
    if (titleSplit.lines && titleSplit.lines.length) {
      /* Avvolge ogni riga in un overflow:hidden per il reveal pulito */
      titleSplit.lines.forEach(function (line) {
        var oh = document.createElement('span');
        oh.style.cssText = 'display:block; overflow:hidden;';
        line.parentNode.insertBefore(oh, line);
        oh.appendChild(line);
      });
      gsap.from(titleSplit.lines, {
        yPercent: 110,
        duration: 1.2,
        ease: 'power4.out',
        stagger: 0.1,
        scrollTrigger: {
          trigger: title,
          start: 'top 85%',
        },
      });
    }
  }

  /* Paragrafi — scrub linea per linea via SplitType */
  var textDiv = section.querySelector('.linee-promessa__text');
  if (textDiv && typeof SplitType !== 'undefined') {
    textDiv.querySelectorAll('p').forEach(function (para) {
      var split = new SplitType(para, { types: 'lines' });
      if (split.lines && split.lines.length) {
        split.lines.forEach(function (line) {
          gsap.fromTo(line,
            { y: 28, opacity: 0 },
            {
              y: 0, opacity: 1, ease: 'none',
              scrollTrigger: {
                trigger: line,
                start: 'top 84%',
                end: 'top 44%',
                scrub: 1.2,
              },
            }
          );
        });
      }
    });
  }
})();


/* ---------- DAFNE IMAGE — circle mask reveal + parallax ---------- */
(function () {
  var wrapper = document.querySelector('.linee-info__img-dafne');
  if (!wrapper) return;

  var maskCircle = wrapper.querySelector('#circleMask-dafne circle');
  var svgImage   = wrapper.querySelector('.linee-info__dafne-svg image');
  if (maskCircle && svgImage) {
    var finalR = parseFloat(maskCircle.getAttribute('data-value-final'));
    if (window.innerWidth <= 1024) {
      maskCircle.setAttribute('r', finalR);
    } else {
      gsap.timeline({
        scrollTrigger: {
          trigger: wrapper,
          start: 'top 45%',
          end: '+=40%',
          scrub: true,
        },
      })
      .fromTo(maskCircle, { attr: { r: 0 } }, { attr: { r: finalR }, ease: 'none' }, 0)
      .fromTo(svgImage, { scale: 1.08, transformOrigin: '50% 50%' }, { scale: 1, ease: 'none' }, 0);
    }
  }

  /* Parallax */
  gsap.fromTo(wrapper, { yPercent: -12 }, {
    yPercent: 12,
    ease: 'none',
    scrollTrigger: {
      trigger: document.querySelector('.linee-info') || wrapper,
      start: 'top bottom',
      end: 'bottom top',
      scrub: 1.5,
    },
  });
})();


/* ---------- LINEE-INFO — parallax colonna sinistra ---------- */
(function () {
  var section = document.querySelector('.linee-info');
  if (!section) return;

  var st = {
    trigger: section,
    start: 'top bottom',
    end: 'bottom top',
    scrub: 2.5,
  };

  /* Titolo — movimento minimo, quasi fermo */
  gsap.fromTo(section.querySelector('.linee-info__title'),
    { yPercent: -3 }, { yPercent: 3, ease: 'none', scrollTrigger: st }
  );

  /* Immagine latte — parallax leggermente più accentuato */
  gsap.fromTo(section.querySelector('.linee-info__img-top'),
    { yPercent: -8 }, { yPercent: 8, ease: 'none', scrollTrigger: st }
  );

  /* Copy testo — velocità intermedia */
  gsap.fromTo(section.querySelector('.linee-info__col-left .linee-info__copy'),
    { yPercent: -5 }, { yPercent: 5, ease: 'none', scrollTrigger: st }
  );
})();


/* ---------- LINEE-INFO — scroll animations ---------- */
(function () {
  var section = document.querySelector('.linee-info');
  if (!section) return;

  /* helper: avvolge ogni riga SplitType in overflow:hidden */
  function wrapLines(lines) {
    lines.forEach(function (line) {
      var oh = document.createElement('span');
      oh.style.cssText = 'display:block; overflow:hidden;';
      line.parentNode.insertBefore(oh, line);
      oh.appendChild(line);
    });
  }

  /* --- Titolo sinistra — SplitType line reveal --- */
  var title = section.querySelector('.linee-info__title');
  if (title && typeof SplitType !== 'undefined') {
    var tSplit = new SplitType(title, { types: 'lines' });
    if (tSplit.lines && tSplit.lines.length) {
      wrapLines(tSplit.lines);
      gsap.from(tSplit.lines, {
        yPercent: 110,
        duration: 1.1,
        ease: 'power3.out',
        stagger: 0.09,
        scrollTrigger: { trigger: title, start: 'top 82%' },
      });
    }
  }

  /* --- Immagine latte (top sx) --- */
  var imgTop = section.querySelector('.linee-info__img-top');
  if (imgTop) {
    gsap.fromTo(imgTop,
      { opacity: 0, y: 50, scale: 1.03 },
      {
        opacity: 1, y: 0, scale: 1,
        duration: 1.3,
        ease: 'power2.out',
        scrollTrigger: { trigger: imgTop, start: 'top 84%' },
      }
    );
  }

  /* --- Copy paragrafi sinistra --- */
  var leftParas = section.querySelectorAll('.linee-info__col-left .linee-info__copy p');
  if (leftParas.length) {
    gsap.fromTo(leftParas,
      { opacity: 0, y: 22 },
      {
        opacity: 1, y: 0,
        duration: 0.9,
        ease: 'power2.out',
        stagger: 0.13,
        scrollTrigger: { trigger: leftParas[0], start: 'top 86%' },
      }
    );
  }

  /* --- Subtitle destra — SplitType line reveal --- */
  var subtitle = section.querySelector('.linee-info__subtitle');
  if (subtitle && typeof SplitType !== 'undefined') {
    var sSplit = new SplitType(subtitle, { types: 'lines' });
    if (sSplit.lines && sSplit.lines.length) {
      wrapLines(sSplit.lines);
      gsap.from(sSplit.lines, {
        yPercent: 110,
        duration: 1.0,
        ease: 'power3.out',
        stagger: 0.09,
        scrollTrigger: { trigger: subtitle, start: 'top 82%' },
      });
    }
  }

  /* --- Benefit items — stagger fade+y --- */
  var benefits = section.querySelectorAll('.linee-info__benefits .dett-info__benefit');
  if (benefits.length) {
    gsap.fromTo(benefits,
      { opacity: 0, y: 18 },
      {
        opacity: 1, y: 0,
        duration: 0.75,
        ease: 'power2.out',
        stagger: 0.1,
        scrollTrigger: { trigger: benefits[0], start: 'top 86%' },
      }
    );
  }

  /* --- Copy grande destra --- */
  var rightParas = section.querySelectorAll('.linee-info__copy.grande p');
  if (rightParas.length) {
    gsap.fromTo(rightParas,
      { opacity: 0, y: 22 },
      {
        opacity: 1, y: 0,
        duration: 0.9,
        ease: 'power2.out',
        stagger: 0.13,
        scrollTrigger: { trigger: rightParas[0], start: 'top 86%' },
      }
    );
  }
})();


/* ---------- DAFNE TITLE BANNER — chars scrub reveal ---------- */
(function () {
  var titleEl = document.querySelector('.linee-dafne-banner__title');
  if (!titleEl || typeof SplitType === 'undefined') return;

  var split = new SplitType(titleEl, { types: 'chars' });
  if (!split.chars || !split.chars.length) return;

  gsap.fromTo(split.chars,
    { y: 80, opacity: 0 },
    {
      y: 0,
      opacity: 1,
      stagger: 0.05,
      ease: 'none',
      scrollTrigger: {
        trigger: titleEl,
        start: 'top 80%',
        end: 'top 20%',
        scrub: 1.5,
      },
    }
  );
})();


/* ---------- PRODOTTI CAROUSEL ---------- */
class ProdottiCarousel {
  constructor() {
    this.section = document.querySelector('#prodotti');
    if (!this.section) return;

    this.track = this.section.querySelector('.prodotti__track');
    this.slides = gsap.utils.toArray(this.section.querySelectorAll('.prodotti__slide'));
    this.bgs = gsap.utils.toArray(this.section.querySelectorAll('.prodotti__bg'));
    this.bgImgs = gsap.utils.toArray(this.section.querySelectorAll('.prodotti__bg-img'));
    this.bottleImgs = gsap.utils.toArray(this.section.querySelectorAll('.prodotti__bottle-img'));
    this.slideInfos = gsap.utils.toArray(this.section.querySelectorAll('.prodotti__slide-info'));
    this.indicatorNum = this.section.querySelector('.prodotti__indicator-num');
    this.previews = gsap.utils.toArray(this.section.querySelectorAll('.prodotti__preview'));

    this.current = 0;
    this.total = this.slides.length;
    this.slideWidth = window.innerWidth;

    this.initPreviews();
    this.init();
  }

  initPreviews() {
    const self = this;
    this.previews.forEach((prev, i) => {
      prev.addEventListener('click', () => {
        self.snapTo(i);
      });
    });
  }

  updatePreviewActive(idx) {
    this.previews.forEach((prev, i) => {
      prev.classList.toggle('prodotti__preview--active', i === idx);
    });
  }

  updateIndicator(idx) {
    if (this.indicatorNum) {
      this.indicatorNum.textContent = String(idx + 1).padStart(2, '0');
    }
  }

  init() {
    this.isMobile = window.matchMedia('(max-width: 1024px)').matches;
    this.updateVisuals();
    if (this.isMobile) {
      this.initMobileSwipe();
    } else {
      this.initScrollDriven();
      this.initMouseDrag();
    }
  }

  initScrollDriven() {
    const self = this;
    const wrap = document.querySelector('#prodotti-wrap');
    const totalSlides = this.total;

    const segments = [
      [0.00, 0.38, 0, 1],
      [0.38, 0.46, 1, 1],
      [0.46, 0.84, 1, 2],
      [0.84, 0.92, 2, 2],
      [0.92, 1.00, 2, 2],
    ];

    function mapProgress(raw) {
      for (let i = 0; i < segments.length; i++) {
        const [rStart, rEnd, sStart, sEnd] = segments[i];
        if (raw <= rEnd) {
          if (sStart === sEnd) return sStart;
          const t = (raw - rStart) / (rEnd - rStart);
          return sStart + t * (sEnd - sStart);
        }
      }
      return totalSlides - 1;
    }

    ScrollTrigger.create({
      trigger: wrap,
      start: 'top top',
      end: 'bottom bottom',
      scrub: 0,
      onUpdate(st) {
        const wrapH = wrap.offsetHeight;
        const vh = window.innerHeight;
        const stickyStart = vh / (wrapH - vh);
        const raw = Math.max(0, (st.progress - stickyStart) / (1 - stickyStart));
        const progress = mapProgress(Math.min(raw, 1));
        const clampedProgress = Math.min(progress, totalSlides - 1);
        const idx = Math.round(clampedProgress);
        gsap.set(self.track, { x: -clampedProgress * self.slideWidth });
        self.updateVisuals();

        if (idx !== self.current) {
          self.current = idx;
          self.updateIndicator(idx);
          self.updatePreviewActive(idx);
        }
      },
    });

    this._wrap = wrap;
    this._segments = segments;

    window.addEventListener('resize', () => {
      this.slideWidth = window.innerWidth;
      ScrollTrigger.refresh();
    });

    if (window.matchMedia('(max-width: 1024px)').matches) {
      this.initSwipe(wrap, segments);
    }
  }

  initMobileSwipe() {
    const self = this;
    const totalWidth = this.total * this.slideWidth;
    let startX = 0;
    let startY = 0;
    let startTrackX = 0;
    let dragging = false;
    let decided = false;

    function wrapSlides() {
      const viewPos = -gsap.getProperty(self.track, 'x');
      self.slides.forEach((slide, i) => {
        const base = i * self.slideWidth;
        let bestOffset = 0;
        let bestDist = Math.abs(base - viewPos);
        for (const off of [-totalWidth, totalWidth]) {
          const d = Math.abs(base + off - viewPos);
          if (d < bestDist) { bestDist = d; bestOffset = off; }
        }
        gsap.set(slide, { x: bestOffset });
      });
    }

    function updateLoop() {
      wrapSlides();
      const trackX = gsap.getProperty(self.track, 'x');
      const rawProgress = -trackX / self.slideWidth;
      const progress = ((rawProgress % self.total) + self.total) % self.total;
      const floor = Math.floor(progress) % self.total;
      const ceil = (floor + 1) % self.total;
      const frac = progress - Math.floor(progress);

      self.bgImgs.forEach((img, i) => {
        let o = 0;
        if (frac < 0.001) o = i === floor ? 1 : 0;
        else if (i === floor) o = 1 - frac;
        else if (i === ceil) o = frac;
        gsap.set(img, { opacity: o });
      });

      self.bgs.forEach((bg, i) => {
        let o = 0;
        if (frac < 0.001) o = i === floor ? 1 : 0;
        else if (i === floor) o = 1 - frac;
        else if (i === ceil) o = frac;
        gsap.set(bg, { opacity: o });
      });

      const viewCenter = self.slideWidth / 2;
      self.slides.forEach((slide, i) => {
        const slideOffset = parseFloat(gsap.getProperty(slide, 'x')) || 0;
        const slideCenter = i * self.slideWidth + self.slideWidth / 2 + trackX + slideOffset;
        const distRaw = (slideCenter - viewCenter) / self.slideWidth;
        const distNorm = Math.min(Math.abs(distRaw), 1);

        let bottleParallax = distRaw > 0 ? distRaw * self.slideWidth * -0.5 : 0;
        const bottleScaleX = 1 - distNorm * 0.19;
        const bottleScaleY = 1 - distNorm * 0.375;

        gsap.set(self.bottleImgs[i], {
          xPercent: -50, yPercent: -50,
          transformOrigin: 'center center',
          x: bottleParallax, y: 0,
          scaleX: bottleScaleX, scaleY: bottleScaleY, opacity: 1,
        });

        const textOpacity = gsap.utils.clamp(0, 1, 1 - distNorm * 1.8);
        const textY = distNorm * 25;
        gsap.set(self.slideInfos[i], { opacity: textOpacity, y: textY });
      });
    }

    this.section.addEventListener('touchstart', (e) => {
      startX = e.touches[0].clientX;
      startY = e.touches[0].clientY;
      startTrackX = gsap.getProperty(self.track, 'x');
      dragging = false;
      decided = false;
    }, { passive: true });

    this.section.addEventListener('touchmove', (e) => {
      const dx = e.touches[0].clientX - startX;
      const dy = e.touches[0].clientY - startY;
      if (!decided && (Math.abs(dx) > 10 || Math.abs(dy) > 10)) {
        decided = true;
        dragging = Math.abs(dx) > Math.abs(dy);
      }
      if (!dragging) return;
      e.preventDefault();
      gsap.set(self.track, { x: startTrackX + dx * 1.8 });
      updateLoop();
    }, { passive: false });

    this.section.addEventListener('touchend', (e) => {
      if (!dragging) return;
      dragging = false;

      const dx = e.changedTouches[0].clientX - startX;
      const threshold = self.slideWidth * 0.2;
      const trackX = gsap.getProperty(self.track, 'x');
      const rawIdx = -trackX / self.slideWidth;

      let target;
      if (Math.abs(dx) > threshold) {
        target = dx < 0 ? Math.ceil(rawIdx) : Math.floor(rawIdx);
      } else {
        target = Math.round(rawIdx);
      }

      gsap.to(self.track, {
        x: -target * self.slideWidth,
        duration: 0.4,
        ease: 'power2.out',
        onUpdate: updateLoop,
        onComplete: () => {
          const norm = ((target % self.total) + self.total) % self.total;
          gsap.set(self.track, { x: -norm * self.slideWidth });
          self.slides.forEach(s => gsap.set(s, { x: 0 }));
          self.current = norm;
          self.updateIndicator(norm);
          self.updatePreviewActive(norm);
          updateLoop();
        },
      });
    }, { passive: true });

    window.addEventListener('resize', () => {
      this.slideWidth = window.innerWidth;
    });
  }

  initSwipe(wrap, segments) {
    const self = this;
    let startX = 0;
    let startY = 0;
    let startTrackX = 0;
    let dragging = false;
    let decided = false;

    this.section.addEventListener('touchstart', (e) => {
      startX = e.touches[0].clientX;
      startY = e.touches[0].clientY;
      startTrackX = gsap.getProperty(self.track, 'x');
      dragging = false;
      decided = false;
    }, { passive: true });

    this.section.addEventListener('touchmove', (e) => {
      const dx = e.touches[0].clientX - startX;
      const dy = e.touches[0].clientY - startY;

      if (!decided && (Math.abs(dx) > 10 || Math.abs(dy) > 10)) {
        decided = true;
        dragging = Math.abs(dx) > Math.abs(dy);
        if (dragging) window.lenis.stop();
      }

      if (!dragging) return;
      e.preventDefault();

      const newX = startTrackX + dx * 1.8;
      const clamped = Math.max(-(self.total - 1) * self.slideWidth, Math.min(0, newX));
      gsap.set(self.track, { x: clamped });
      self.updateVisuals();
    }, { passive: false });

    this.section.addEventListener('touchend', (e) => {
      if (!dragging) return;
      dragging = false;
      window.lenis.start();

      const dx = e.changedTouches[0].clientX - startX;
      const threshold = self.slideWidth * 0.2;
      let target;
      if (Math.abs(dx) > threshold) {
        target = dx < 0 ? self.current + 1 : self.current - 1;
      } else {
        target = Math.round(-gsap.getProperty(self.track, 'x') / self.slideWidth);
      }
      target = Math.max(0, Math.min(target, self.total - 1));

      gsap.to(self.track, {
        x: -target * self.slideWidth,
        duration: 0.4,
        ease: 'power2.out',
        onUpdate: () => self.updateVisuals(),
      });

      self.current = target;
      if (self.indicatorNum) {
        self.indicatorNum.textContent = String(target + 1).padStart(2, '0');
      }

      const deadZoneCenters = [0, 0.42, 0.88];
      const rawTarget = deadZoneCenters[target];
      const wrapH = wrap.offsetHeight;
      const vh = window.innerHeight;
      const stickyStart = vh / (wrapH - vh);
      const stProgress = rawTarget * (1 - stickyStart) + stickyStart;
      const scrollTarget = wrap.offsetTop + stProgress * (wrapH - vh);

      window.lenis.scrollTo(scrollTarget, { duration: 0.01, immediate: true });
    }, { passive: true });
  }

  initMouseDrag() {
    const self = this;
    let startX = 0;
    let startTrackX = 0;
    let dragging = false;

    this.section.addEventListener('mousedown', (e) => {
      // Ignore if clicking on buttons/links
      if (e.target.closest('a, button')) return;
      startX = e.clientX;
      startTrackX = gsap.getProperty(self.track, 'x');
      dragging = true;
      self.section.style.cursor = 'grabbing';
      e.preventDefault();
    });

    window.addEventListener('mousemove', (e) => {
      if (!dragging) return;
      const dx = e.clientX - startX;
      const newX = startTrackX + dx;
      const clamped = Math.max(-(self.total - 1) * self.slideWidth, Math.min(0, newX));
      gsap.set(self.track, { x: clamped });
      self.updateVisuals();
    });

    window.addEventListener('mouseup', (e) => {
      if (!dragging) return;
      dragging = false;
      self.section.style.cursor = '';

      const dx = e.clientX - startX;
      const threshold = self.slideWidth * 0.15;
      let target;
      if (Math.abs(dx) > threshold) {
        target = dx < 0 ? self.current + 1 : self.current - 1;
      } else {
        target = Math.round(-gsap.getProperty(self.track, 'x') / self.slideWidth);
      }
      target = Math.max(0, Math.min(target, self.total - 1));

      gsap.to(self.track, {
        x: -target * self.slideWidth,
        duration: 0.5,
        ease: 'power2.out',
        onUpdate: () => self.updateVisuals(),
      });

      self.current = target;
      self.updateIndicator(target);
      self.updatePreviewActive(target);
    });
  }

  updateVisuals() {
    const trackX = gsap.getProperty(this.track, 'x');
    const progress = Math.max(0, Math.min(-trackX / this.slideWidth, this.total - 1));
    const floor = Math.floor(progress);
    const ceil = Math.min(floor + 1, this.total - 1);
    const frac = progress - floor;

    this.bgImgs.forEach((img, i) => {
      let o = 0;
      if (floor === ceil) o = i === floor ? 1 : 0;
      else if (i === floor) o = 1 - frac;
      else if (i === ceil) o = frac;
      gsap.set(img, { opacity: o });
    });

    this.bgs.forEach((bg, i) => {
      let o = 0;
      if (floor === ceil) o = i === floor ? 1 : 0;
      else if (i === floor) o = 1 - frac;
      else if (i === ceil) o = frac;
      gsap.set(bg, { opacity: o });
    });

    const viewCenter = this.slideWidth / 2;

    this.slides.forEach((slide, i) => {
      const slideCenter = i * this.slideWidth + this.slideWidth / 2 + trackX;
      const distRaw = (slideCenter - viewCenter) / this.slideWidth;
      const distNorm = Math.min(Math.abs(distRaw), 1);

      let bottleParallax;
      if (distRaw > 0) {
        bottleParallax = distRaw * this.slideWidth * -0.5;
      } else {
        bottleParallax = 0;
      }

      const bottleScaleX = 1 - distNorm * 0.19;
      const bottleScaleY = 1 - distNorm * 0.375;

      gsap.set(this.bottleImgs[i], {
        xPercent: -50,
        yPercent: -50,
        transformOrigin: 'center center',
        x: bottleParallax,
        y: 0,
        scaleX: bottleScaleX,
        scaleY: bottleScaleY,
        opacity: 1,
      });

      const textOpacity = gsap.utils.clamp(0, 1, 1 - distNorm * 1.8);
      const textY = distNorm * 25;

      gsap.set(this.slideInfos[i], {
        opacity: textOpacity,
        y: textY,
      });
    });
  }

  snapTo(index) {
    index = Math.max(0, Math.min(index, this.total - 1));
    this.current = index;

    gsap.to(this.track, {
      x: -index * this.slideWidth,
      duration: 1.1,
      ease: 'power2.inOut',
      onUpdate: () => this.updateVisuals(),
    });

    if (this.indicatorNum) {
      this.indicatorNum.textContent = String(index + 1).padStart(2, '0');
    }
    this.updatePreviewActive(index);
  }
}

new ProdottiCarousel();

/* --- Prodotti slide-1: testi intro on-scroll --- */
(function () {
  var section  = document.querySelector('#prodotti');
  if (!section) return;
  var wrap     = document.querySelector('#prodotti-wrap') || section;
  var slide0   = section.querySelector('.prodotti__slide');
  var info0    = slide0 && slide0.querySelector('.prodotti__slide-info');
  var infoEls  = info0 ? Array.from(info0.querySelectorAll('.prodotti__label, .prodotti__name, .prodotti__price, .prodotti__explore-cta')) : [];
  var infoText = info0 && info0.querySelector('.info-testo');
  if (!infoEls.length) return;

  gsap.set(infoEls,  { opacity: 0, y: 28 });
  if (infoText) gsap.set(infoText, { opacity: 0, y: 20 });

  var bgStatic = section.querySelector('.prodotti__bg-static');
  if (bgStatic) gsap.set(bgStatic, { opacity: 0 });

  var done = false;
  function check() {
    if (done) return;
    var rect = wrap.getBoundingClientRect();
    if (rect.top < window.innerHeight * 0.85) {
      done = true;
      var tl = gsap.timeline();

      /* sfondo pillola: fade in */
      if (bgStatic) tl.to(bgStatic,
        { opacity: 1, duration: 1.1, ease: 'power3.out', overwrite: 'auto' },
        0
      );

      /* testi */
      tl.to(infoEls, { opacity: 1, y: 0, stagger: 0.1, duration: 0.65, ease: 'power3.out', overwrite: 'auto' }, 0.2);
      if (infoText) tl.to(infoText, { opacity: 1, y: 0, duration: 0.6, ease: 'power2.out', overwrite: 'auto' }, '+=0.4');
    }
  }

  check();
  var lenisInst = window.lenis;
  if (lenisInst) {
    lenisInst.on('scroll', check);
  } else {
    window.addEventListener('scroll', check, { passive: true });
  }
})();


/* ---------- LINEA STORY — Expanding pill + copy reveal ---------- */
class LineaStory {
  constructor() {
    this.section = document.querySelector('#linea-story');
    if (!this.section) return;

    this.type = this.section.querySelector('.linea-story__type');
    this.pill = this.section.querySelector('.linea-story__pill');
    this.animTexts = this.section.querySelectorAll('.linea-story__anim');
    this.textBefore = this.section.querySelectorAll('.linea-story__text-before');
    this.copy = this.section.querySelector('.linea-story__copy');
    this.title = this.section.querySelector('.linea-story__title');

    this.isMobile = window.matchMedia('(max-width: 1024px)').matches;

    if (this.isMobile) {
      this.initMobile();
    } else {
      this.initExpand();
      this.initCopyLines();
      this.initGiantTitle();
    }
  }

  initMobile() {
    if (this.type) {
      gsap.set(this.type, { opacity: 0, y: 40 });
      gsap.to(this.type, {
        opacity: 1, y: 0, ease: 'none',
        scrollTrigger: { trigger: this.section, start: 'top 80%', end: 'top 50%', scrub: 1.2 },
      });
    }

    if (this.pill) {
      gsap.set(this.pill, { clipPath: 'inset(12% 12% 12% 12%)', opacity: 0 });
      gsap.to(this.pill, {
        clipPath: 'inset(0% 0% 0% 0%)', opacity: 1, ease: 'sine.inOut',
        scrollTrigger: { trigger: this.pill, start: 'top 90%', end: 'top 55%', scrub: 1.2 },
      });
    }

    if (this.copy && typeof SplitType !== 'undefined') {
      var copySplit = new SplitType(this.copy, { types: 'lines' });
      if (copySplit.lines && copySplit.lines.length) {
        copySplit.lines.forEach(function (line) {
          gsap.fromTo(line, { y: 30, opacity: 0 }, {
            y: 0, opacity: 1, ease: 'none',
            scrollTrigger: { trigger: line, start: 'top 85%', end: 'top 45%', scrub: 1.5 },
          });
        });
      }
    }

    if (this.title) {
      gsap.fromTo(this.title, { opacity: 0 }, {
        opacity: 1, ease: 'none',
        scrollTrigger: { trigger: this.copy || this.pill || this.section, start: 'bottom 90%', end: 'bottom 50%', scrub: 1.5 },
      });
    }
  }

  initExpand() {
    if (!this.type || !this.pill) return;

    var pillInner = this.pill.querySelector('.linea-story__pill-inner');
    var expand = this.type.querySelector('.linea-story__expand');

    var tl = gsap.timeline({
      scrollTrigger: { trigger: this.type, start: 'top 85%', end: 'center center', scrub: 1.2 },
    });

    tl.to(this.pill, { width: 600, maxWidth: '90vw', ease: 'sine.inOut' }, 0);
    if (pillInner) tl.to(pillInner, { width: 600, maxWidth: '90vw', ease: 'sine.inOut' }, 0);
    if (expand) tl.to(expand, { gap: '0.5rem', ease: 'sine.inOut' }, 0);
  }

  initCopyLines() {
    if (!this.copy || typeof SplitType === 'undefined') return;

    this.copySplit = new SplitType(this.copy, { types: 'lines' });
    if (!this.copySplit.lines || !this.copySplit.lines.length) return;

    this.copySplit.lines.forEach(function (line) {
      gsap.fromTo(line, { y: 30, opacity: 0 }, {
        y: 0, opacity: 1, ease: 'none',
        scrollTrigger: { trigger: line, start: 'top 60%', end: 'top 20%', scrub: 1.5 },
      });
    });
  }

  initGiantTitle() {
    if (!this.title || typeof SplitType === 'undefined') return;

    this.titleSplit = new SplitType(this.title, { types: 'chars' });
    if (!this.titleSplit.chars || !this.titleSplit.chars.length) return;

    gsap.fromTo(this.titleSplit.chars, { y: 80, opacity: 0 }, {
      y: 0, opacity: 1, stagger: 0.05, ease: 'none',
      scrollTrigger: { trigger: this.title, start: 'top 50%', end: 'top 10%', scrub: 1.5 },
    });
  }
}

new LineaStory();


/* ---------- LINES SECTION — Grid intro + Flip content panels ---------- */
(function () {
  var linesSection = document.querySelector('#lines-section');
  if (!linesSection) return;

  var linesGrid = linesSection.querySelector('.lines-grid');
  var introTexts = gsap.utils.toArray(linesGrid.querySelectorAll('.lines-oh > span'));
  var images = gsap.utils.toArray(linesGrid.querySelectorAll('.lines-grid__image'));
  var imageHomes = images.map(function (img) { return img.parentElement; });
  var contentWrap = linesSection.querySelector('.lines-content-wrap');
  var contents = gsap.utils.toArray(linesSection.querySelectorAll('.lines-content'));
  var contentRowImages = gsap.utils.toArray(linesSection.querySelectorAll('.lines-content__row--image'));
  var contentBackCtrls = gsap.utils.toArray(linesSection.querySelectorAll('.lines-content__back'));

  var contentTexts = contents.map(function (c) {
    return gsap.utils.toArray(c.querySelectorAll('.lines-oh > span'));
  });

  var isAnimating = false;
  var entranceKilled = false;

  function killEntrance() {
    if (entranceKilled) return;
    entranceKilled = true;
    entranceTl.progress(1);
    if (entranceTl.scrollTrigger) entranceTl.scrollTrigger.kill();
    entranceTl.kill();
    gsap.set(introTexts, { clearProps: 'xPercent,yPercent' });
    gsap.set(images, { clearProps: 'scale,opacity' });
    gsap.set(imageInners, { clearProps: 'scale' });
  }

  // Initial hidden states
  gsap.set(introTexts, {
    yPercent: function (_, target) {
      var dir = target.dataset.direction;
      if (dir === 'top') return -101;
      if (dir === 'bottom') return 101;
      return 0;
    },
    xPercent: function (_, target) {
      var dir = target.dataset.direction;
      if (dir === 'left') return -101;
      if (dir === 'right') return 101;
      return 0;
    },
  });

  var imageInners = gsap.utils.toArray(linesGrid.querySelectorAll('.lines-grid__image-inner'));
  gsap.set(images, { scale: 0.8, opacity: 0 });
  gsap.set(imageInners, { scale: 1.2 });

  var isDesktop = window.matchMedia('(min-width: 1025px)').matches;

  var entranceTl = gsap.timeline({
    onComplete: isDesktop ? undefined : function () { killEntrance(); },
    scrollTrigger: isDesktop
      ? { trigger: linesSection, start: 'top top', end: 'bottom bottom', scrub: 1 }
      : { trigger: linesSection, start: 'top 80%', toggleActions: 'play none none none' },
  });

  entranceTl.to(introTexts, {
    xPercent: 0, yPercent: 0, duration: 1.1, ease: 'power2.out', stagger: 0.08,
  });

  entranceTl.to(images, {
    scale: 1, opacity: 1, duration: 1, ease: 'power2.out', stagger: 0.15,
  }, '-=0.8');

  entranceTl.to(imageInners, {
    scale: 1, duration: 1.2, ease: 'power2.out', stagger: 0.15,
  }, '<');

  // Open content
  function openContent(image, position) {
    if (isAnimating) return;
    isAnimating = true;
    killEntrance();
    window.lenis.stop();
    contentWrap.classList.add('lines-content-wrap--fixed');
    linesSection.style.zIndex = '99999';

    var otherImageInners = images
      .filter(function (el) { return el !== image; })
      .map(function (el) { return el.querySelector('.lines-grid__image-inner'); });

    gsap.timeline({
      defaults: { duration: 1.1, ease: 'power4.inOut' },
      onComplete: function () { isAnimating = false; },
    })
    .addLabel('start', 0)
    .add(function () {
      var state = Flip.getState(image);
      contentRowImages[position].appendChild(image);
      Flip.from(state, { duration: 1.2, ease: 'power4.inOut', absolute: true });
      linesGrid.classList.add('lines-grid--close');
      contents[position].classList.add('lines-content--open');
      gsap.set(contentBackCtrls[position], { xPercent: 20, opacity: 0 });
      gsap.set(contentTexts[position], { yPercent: 101 });
    }, 'start')
    .to([introTexts, otherImageInners], {
      xPercent: function (_, target) {
        switch (target.dataset.direction) {
          case 'right': return 101;
          case 'left': return -101;
          default: return 0;
        }
      },
      yPercent: function (_, target) {
        switch (target.dataset.direction) {
          case 'top': return -101;
          case 'bottom': return 101;
          default: return 0;
        }
      },
    }, 'start')
    .addLabel('content', 'start+=0.7')
    .to(contentTexts[position], { ease: 'expo', yPercent: 0 }, 'content')
    .to(contentBackCtrls[position], { ease: 'expo', xPercent: 0, opacity: 1 }, 'content');
  }

  // Close content
  function closeContent(image, position) {
    if (isAnimating) return;
    isAnimating = true;

    var otherImageInners = images
      .filter(function (el) { return el !== image; })
      .map(function (el) { return el.querySelector('.lines-grid__image-inner'); });

    gsap.timeline({
      defaults: { duration: 1.1, ease: 'power4.inOut' },
      onComplete: function () {
        linesGrid.classList.remove('lines-grid--close');
        contents[position].classList.remove('lines-content--open');
        gsap.set(contents[position], { clearProps: 'opacity' });
        contentWrap.classList.remove('lines-content-wrap--fixed');
        isAnimating = false;
        linesSection.style.zIndex = '';
        window.lenis.start();
      },
    })
    .addLabel('start', 0)
    .to(contentTexts[position], { duration: 0.8, yPercent: 101 }, 'start')
    .to(contentBackCtrls[position], { duration: 0.8, xPercent: 20, opacity: 0 }, 'start')
    .add(function () {
      var state = Flip.getState(image);
      imageHomes[position].appendChild(image);
      Flip.from(state, { duration: 1.2, ease: 'power4.inOut', absolute: true });
    }, 'start')
    .to(contents[position], { opacity: 0, duration: 0.4 }, 'start+=0.4')
    .addLabel('intro', 'start+=0.6')
    .to(introTexts, { ease: 'expo', xPercent: 0, yPercent: 0 }, 'intro')
    .to(otherImageInners, { ease: 'power3.out', duration: 1.3, xPercent: 0, yPercent: 0 }, 'intro');
  }

  // Click handlers
  images.forEach(function (image, position) {
    image.addEventListener('click', function () { openContent(image, position); });
  });

  contentBackCtrls.forEach(function (ctrl, position) {
    ctrl.addEventListener('click', function () { closeContent(images[position], position); });
  });
})();


/* ---------- FOOTER — cursor dark ---------- */
(function () {
  var footer = document.querySelector('.footer');
  var cursor = document.getElementById('cursor');
  if (!footer || !cursor) return;

  ScrollTrigger.create({
    trigger: footer,
    start: 'top bottom',
    end: 'bottom bottom',
    onEnter:     function () { cursor.classList.add('Cursor--dark'); },
    onLeaveBack: function () { cursor.classList.remove('Cursor--dark'); },
  });
})();
